module.exports = __webpack_public_path__ + "static/img/pic19.1.22693f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic19.1.png
// module id = iadI
// module chunks = 0